import { Box, CircularProgress } from "@mui/material";
import { useEntityDocument } from "../../../hooks/Entity";
import EntityDocuments from "../../Entities/Documents/EntityDocuments";

interface DocumentsTabProps {
  entityId?: string;
  entityName?: string;
  handleError?: (err: any) => void;
}

const DocumentsTab: React.FC<DocumentsTabProps> = ({ entityId, entityName, handleError }) => {
  const { documentsData, isPending, createDocument, updateDocument, deleteDocument } = useEntityDocument(entityId);

  if (isPending && documentsData.length === 0)
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );

  return (
    <EntityDocuments
      entityId={Number(entityId)}
      entityName={entityName ?? ""}
      documentsData={documentsData}
      onCreate={async (values) => {
        await createDocument(values).catch(handleError)
      }}
      onUpdate={async (id, values) => {
        await updateDocument({ DocumentId: id, values }).catch(handleError)
      }}
      onDelete={async (id) => {
        await deleteDocument(id).catch(handleError)
      }}
    />
  );
};

export default DocumentsTab;